import I18n from 'I18n';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Small } from 'foundations-components/transitional/components/Small';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Installed = () => {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: SuccessIcon,
      size: "100",
      paddingInlineStart: "0",
      marginInlineStart: "0"
    }), /*#__PURE__*/_jsx(Small, {
      use: "help",
      tagName: "span",
      typography: "detail-200",
      children: I18n.text('authorizationStatus.installed')
    })]
  });
};